import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _ai-c _flexwrap _gap-1 _mt-3" }
const _hoisted_2 = { class: "_mt-0 _tc--base" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_base_label = _resolveComponent("icon-base-label")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_icon_base_label, {
      theme: "accent",
      icon: "check",
      shape: "badge",
      "icon-size": "lg",
      class: "_flex",
      "data-qa": "stretch-pay-success-tick-mark"
    }),
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_localize, {
        resource: _ctx.Resources.ProjectHome.StretchPayAvailableInfo
      }, {
        default: _withCtx(() => [
          _createVNode(_component_themed_image, {
            "format-key": "0",
            src: "/content/images/static/stretch-pay/installments-logo.svg",
            alt: "stretchPay",
            width: "91"
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["resource"])
    ])
  ]))
}